// @ts-nocheck
/* eslint-disable */
/* GENERATED USING build-GemIcons.ts - DO NOT MODIFY */
import { ReactComponent as LogoEmr } from '../../../assets/images/Logos/logo-emr.svg?react';
import { withLogoClass } from '../../withLogoClass';
export const LogoEmrIcon = /* @__PURE__ */ withLogoClass(LogoEmr);
